import { render, staticRenderFns } from "./ProjectViewSidebarActivitiesCard.vue?vue&type=template&id=3f00ecb0&scoped=true"
import script from "./ProjectViewSidebarActivitiesCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarActivitiesCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarActivitiesCard.vue?vue&type=style&index=0&id=3f00ecb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00ecb0",
  null
  
)

export default component.exports